import { BellIcon, CheckCircleIcon, HomeIcon, PhoneIcon, SparklesIcon } from '@heroicons/react/24/outline';
import { ExclamationCircleIcon } from '@heroicons/react/24/solid';
import { CookingPotIcon, FIleCheck2Icon, PlaneNavigationIcon, SendingBikeIcon, ShoppingBagIcon, DineInProsesIcon, SmookingCookingPotIcon } from '../../../utils/svg';
import { cleanText, formatPhoneNumber, isEmptyData } from '../../../utils/helper';
import { useSelector } from 'react-redux';
import { ChevronRightIcon } from '@heroicons/react/24/solid';
import ImageLoader from '../../ImageLoader';
import { useEffect, useState } from 'react';
import Modal from '../../Modal';
import useNavigation from '../../../hook/useNavigation';
import { useLocation } from 'react-router-dom';

const Delivery = () => {
	const navigate = useNavigation();
	const location = useLocation();
	const currentPath = location.pathname;

	const user = useSelector((store) => store?.user);
	const { detail } = useSelector((store) => store.order);
	const { process: step, tracking_url, courier_name, courier_phone, courier_image, license_plate } = detail?.order_process || {};

	const [popup, setPopup] = useState({
		show: false,
		confirm: false,
		type: null,
		value: null,
	});

	const orderType = detail.orderType;

	const driverName = detail?.delivery_order_details?.track?.courier?.name || detail?.delivery_courier_name || courier_name || '';
	const driverPhone = detail?.delivery_order_details?.track?.courier?.phone || detail?.delivery_courier_phone || courier_phone || '';
	const trackingUrl = detail?.delivery_order_details?.trackingUrl || detail?.delivery_tracking_url || tracking_url || '';

	const handleClickTrackingUrl = () => {
		if (user?.is_b2b && user?.companyName?.toLowerCase() !== 'bri') {
			return handlePopup('tracking', trackingUrl);
		}
		return handleTracking(trackingUrl);
	};

	const handleClickCall = () => {
		if (user?.is_b2b) {
			return handlePopup('call', driverPhone);
		}
		return handleCall(driverPhone);
	};

	const handlePopup = (type, value) => {
		setPopup((prev) => {
			return {
				...prev,
				show: true,
				type,
				value,
			};
		});
	};

	const handleCall = (phone = '') => {
		const driverPhone = formatPhoneNumber(phone);
		if (driverPhone) {
			const formated = `tel:${driverPhone}`;
			window.location.href = formated;
		}
	};

	const handleChat = (phone = '') => {
		// const driverPhone = formatPhoneNumberWa(phone);
		// if (driverPhone && user?.is_b2b) {
		//   // bca new tab
		//   window.open(`https://wa.me/${driverPhone}`, '_blank');
		// } else {
		//   const formated = `https://wa.me/${driverPhone}`;
		//   window.location.href = formated;
		// }
	};

	const handleTracking = (link = '') => {
		// bca new tab
		if (link && user?.is_b2b && user?.companyName?.toLowerCase() !== 'bri') {
			window.open(link, '_blank');
		} else {
			return navigate.push({
				pathname: '/tracking',
				state: {
					trackingUrl: link.replace(/^http:\/\//i, 'https://') || '',
					backPath: currentPath ?? '/',
				},
			});
		}
	};

	useEffect(() => {
		if (popup?.confirm && !popup?.show && popup?.type === 'call') {
			handleCall(popup?.value);
		}
		if (popup?.confirm && !popup?.show && popup?.type === 'wa') {
			handleChat(popup?.value);
		}
		if (popup?.confirm && !popup?.show && popup?.type === 'tracking') {
			handleTracking(popup?.value);
		}
		if (popup.confirm && !popup?.show) {
			setPopup({
				show: false,
				confirm: false,
				type: null,
				value: null,
			});
		}
	}, [popup]);

	if (cleanText(orderType) !== 'delivery' || cleanText(step) !== 'dikirim') return null;

	return (
		<>
			<div className={`gap-2 p-2 bg-emerald-600 rounded-lg mt-4 flex items-center justify-between  ${cleanText(step) !== 'dikirim' && 'hidden'}`}>
				<div className='flex items-center gap-2'>
					<div className='h-2 w-2 bg-white rounded-full animate-pulse' />
					<div className='text-white text-xxs'>Live Tracking</div>
				</div>
				<div className={`text-white text-xxs bg-emerald-800/80 py-1 px-3 rounded-full flex items-center gap-1 ${isEmptyData(trackingUrl) && 'hidden'}`} onClick={handleClickTrackingUrl}>
					<div>Buka Peta</div>
					<ChevronRightIcon className='text-white h-3 w-3' />
				</div>
			</div>
			<div className={`bg-purple-900 mt-4 p-4 rounded-lg flex flex-col gap-3 ${cleanText(step) !== 'dikirim' && 'hidden'}`}>
				<div className='flex gap-2'>
					<ImageLoader className='h-10 w-10 rounded-full border-none' src={courier_image} alt={courier_image} />
					<div className='flex flex-col justify-center'>
						<div className='font-semibold text-xs text-white'>{driverName}</div>
						<div className='font-thin text-xxs text-white'>{license_plate}</div>
					</div>
				</div>
				<div className={`w-full bg-emerald-500 rounded-lg flex h-8 items-center gap-2 justify-center ${isEmptyData(driverPhone) && 'hidden'}`} onClick={handleClickCall}>
					<PhoneIcon className='h-4 w-4 text-white' />
					<div className='text-xxs text-white font-normal'>Panggil Driver</div>
				</div>
			</div>
			{popup?.show && (
				<Modal
					isOpen={popup?.show}
					onClose={() => {
						setPopup({
							show: false,
							confirm: false,
							type: null,
							value: null,
						});
					}}>
					<div className={`bg-white p-4 rounded-xl shadow-custom transition-transform duration-1000 ease-in-out ${popup?.show ? 'translate-y-0 relative' : 'translate-y-full hidden'}`}>
						<div className='flex justify-center'>
							<div className='bg-gray-300 h-1.5 w-10 rounded-full' />
						</div>
						<div className='items-center flex justify-center mt-8'>
							<ExclamationCircleIcon className='h-14 w-auto fill-[var(--rose-violet)]' />
						</div>
						<div className='my-5 text-center'>
							<div className='text-gray-900 text-sm font-semibold'>{`Anda akan diarahkan ke aplikasi ${popup?.type === 'call' ? 'Telepon' : popup?.type === 'tracking' ? 'Browser' : 'WhatsApp'}`}</div>
							<div className='text-gray-900 text-xs pt-2'>Apakah Anda yakin ingin melanjutkan?</div>
						</div>
						<div className='flex justify-between mt-2 gap-4'>
							<button
								className='w-full bg-white text-[var(--rose-violet)] border-[var(--rose-violet)] font-semibold text-sm p-3 items-center border'
								onClick={() => {
									setPopup({
										show: false,
										confirm: false,
										type: null,
										value: null,
									});
								}}
								id='merchant_change_cart_cancel'>
								Batal
							</button>
							<button
								onClick={() => {
									setPopup((prev) => {
										return {
											...prev,
											show: false,
											confirm: true,
										};
									});
								}}
								className='w-full bg-[var(--rose-violet)] text-white font-semibold text-sm p-3 items-center border-0'
								id='merchant_change_cart_confirm'>
								Ya, Lanjutkan
							</button>
						</div>
					</div>
				</Modal>
			)}
		</>
	);
};

const Pickup = () => {
	const { detail } = useSelector((store) => store.order);
	const { process: step } = detail?.order_process || {};
	const orderType = detail.orderType;

	if (cleanText(orderType) !== 'pickup' || step !== 'dikirim') return null;

	return (
		<div className='bg-emerald-900 text-white rounded-2xl p-4 shadow-lg space-y-3 border border-emerald-800 mt-4'>
			<div className='flex items-center justify-between'>
				<span className='text-xs text-emerald-200 font-semibold'>Kode PIN Ambil Pesanan</span>
				<span className='px-2 py-0.5 bg-emerald-800 text-emerald-200 text-[10px] font-bold rounded'>KONTER #2</span>
			</div>
			<div className='text-center bg-emerald-950/80 p-3 rounded-xl border border-emerald-700/60'>
				<div className='text-2xl font-black font-mono tracking-widest text-emerald-300'>#UF-9284</div>
				<div className='text-[10px] text-emerald-400 mt-1'>Tunjukkan PIN ini kepada staf kasir outlet</div>
			</div>
			<button className='w-full py-2.5 bg-emerald-500 hover:bg-emerald-600 text-white font-bold rounded-xl text-xs transition flex items-center justify-center gap-2'>
				<i data-lucide='qr-code' className='w-4 h-4'></i>
				<span>Tampilkan QR Code Pick-up</span>
			</button>
		</div>
	);
};

const Dinein = () => {
	const { detail } = useSelector((store) => store.order);
	const { process: step } = detail?.order_process || {};
	const orderType = detail.orderType;

	if (cleanText(orderType) !== 'dinein' || step !== 'dikirim') return null;

	return (
		<div className='bg-amber-900 text-white rounded-2xl p-4 shadow-lg space-y-3 border border-amber-800 mt-4'>
			<div className='flex items-center justify-between'>
				<span className='text-xs text-amber-200 font-semibold'>Nomor Meja Pelanggan</span>
				<span className='px-2.5 py-0.5 bg-amber-800 text-amber-200 text-xs font-black rounded-lg'>MEJA #12</span>
			</div>
			<div className='text-xs text-amber-100/90 leading-relaxed'>Pesanan sedang diantarkan langsung oleh staf pelayan restoran ke meja Anda.</div>
			<div className='grid grid-cols-2 gap-2 pt-1'>
				<button className='py-2.5 bg-amber-500 hover:bg-amber-600 text-white font-bold rounded-xl text-xs transition flex items-center justify-center gap-1.5'>
					<i data-lucide='bell' className='w-3.5 h-3.5'></i>
					<span>Panggil Pelayan</span>
				</button>
				<button className='py-2.5 bg-amber-800 hover:bg-amber-700 text-amber-100 font-bold rounded-xl text-xs transition flex items-center justify-center gap-1.5 border border-amber-700'>
					<i data-lucide='plus-circle' className='w-3.5 h-3.5'></i>
					<span>Tambah Menu</span>
				</button>
			</div>
		</div>
	);
};

const Status = () => {
	const { detail } = useSelector((store) => store.order);
	const { process: step, courier_name, license_plate } = detail?.order_process || {};

	const orderType = detail.orderType;

	const licensePlateSuffix = !isEmptyData(license_plate) ? ` (${license_plate})` : '';

	const STEPS = [
		{ key: 'diterima', label: 'Diterima', Icon: FIleCheck2Icon },
		{ key: 'dimasak', label: 'Dimasak', Icon: cleanText(orderType) === 'delivery' ? CookingPotIcon : SmookingCookingPotIcon },
		{ 
			key: cleanText(orderType) === 'delivery' 
				? 'dikirim' 
				: cleanText(orderType) === 'dinein' 
				? 'disajikan' 
				: 'siap ambil', 
			label: cleanText(orderType) === 'delivery' 
				? 'Dikirim' 
				: cleanText(orderType) === 'dinein' 
				? 'Disajikan' 
				: 'Siap Ambil', 
			Icon: cleanText(orderType) === 'delivery' 
				? SendingBikeIcon 
				: cleanText(orderType) === 'dinein' 
				? DineInProsesIcon 
				: ShoppingBagIcon 
		},
		{ key: 'selesai', label: 'Selesai', Icon: HomeIcon },
	];

	const DESCS = [
		{
			key: 'diterima',
			desc: `Restoran ${detail?.orderItems?.[0]?.storeName} sedang menyiapkan bahan pesanan Anda.`,
			Icon: BellIcon,
			classNameIcon: 'h-5 w-5 !text-[var(--rose-violet)]',
		},
		{
			key: 'dimasak',
			desc: cleanText(orderType) === 'delivery' ? `Driver ${courier_name}${licensePlateSuffix} telah ditugaskan dan menuju resto.` : `Restoran ${detail?.orderItems?.[0]?.storeName} sedang menyiapkan bahan pesanan Anda.`,
			Icon: CheckCircleIcon,
			classNameIcon: 'h-5 w-5 !text-[var(--rose-violet)]',
		},
		{
			key: 'dikirim',
			desc: cleanText(orderType) === 'delivery' ? 'Driver mendekati lokasi pengantaran Anda (~ 5 menit lagi).' : null,
			Icon: PlaneNavigationIcon,
			classNameIcon: 'h-4 w-4 !text-[var(--rose-violet)]',
		},
		{
			key: 'selesai',
			desc: 'Terima kasih telah memesan via UFOOD Delivery! Selamat menikmati hidangan.',
			Icon: SparklesIcon,
			classNameIcon: 'h-5 w-5 !text-[var(--rose-violet)]',
		},
	];

	const stepCount = STEPS.length;
	const currentStep = STEPS.findIndex((s) => cleanText(s.key) === cleanText(step));
	const isInProgress = currentStep >= 0 && currentStep < stepCount - 1;

	const currentDesc = DESCS.find((s) => cleanText(s.key) === cleanText(step));
	const IconDesc = currentDesc?.Icon;

	if (Number(detail?.orderStatus) === 0 || Number(detail?.orderStatus) === 5 || isEmptyData(step)) return null;

	return (
		<div className='p-4'>
			<style>
				{`
					@keyframes status-line-shimmer {
						0% { transform: translateX(-100%); }
						100% { transform: translateX(300%); }
					}
					.status-line-shimmer {
						animation: status-line-shimmer 1.6s ease-in-out infinite;
					}
					@media (prefers-reduced-motion: reduce) {
						.status-line-shimmer { animation: none; }
					}
				`}
			</style>
			<div className='bg-white p-4 rounded-md shadow-md w-full'>
				<div className='flex items-center gap-2 mb-2'>
					<PlaneNavigationIcon className='h-4 w-4 text-[var(--rose-violet)]' />
					<div className='text-sm text-gray-700'>Lacak pesanan anda</div>
				</div>
				<div className='border-b-1 border-solid pb-2 border-gray-200 my-2 mb-4' />
				<div className='relative flex items-start w-full'>
					<div className='absolute top-4 h-[0.175rem] rounded-full bg-gray-200 z-0' style={{ left: `calc(100% / ${stepCount * 2})`, right: `calc(100% / ${stepCount * 2})` }} />
					<div
						className='absolute top-4 h-[0.175rem] rounded-full overflow-hidden bg-[var(--rose-violet)] z-0 transition-all duration-500'
						style={{ left: `calc(100% / ${stepCount * 2})`, width: `calc(100% / ${stepCount} * ${Math.max(currentStep, 0)})` }}>
						{isInProgress && <div className='status-line-shimmer absolute inset-y-0 left-0 w-1/3 bg-gradient-to-r from-transparent via-white/80 to-transparent' />}
					</div>
					{STEPS.map((item, index) => {
						const isActive = index <= currentStep;
						const IconStep = item.Icon;
						return (
							<div key={item.key} className='relative flex flex-1 flex-col items-center'>
								<div className={`h-9 w-9 rounded-md flex items-center justify-center border-2 ${isActive ? 'bg-[var(--rose-violet)] border-[var(--rose-violet)]' : 'bg-gray-100 border-gray-300'}`}>
									<IconStep className={`h-4 w-4 ${isActive ? 'text-white' : 'text-gray-400'}`} />
								</div>
								<div className={`mt-1.5 text-center text-xxs ${isActive ? 'text-[var(--rose-violet)] font-medium' : 'text-gray-400'}`}>{item.label}</div>
							</div>
						);
					})}
				</div>
				{IconDesc && (
					<div className={`p-4 mt-4 rounded-lg bg-[var(--rose-violet-opacity)] flex gap-2 ${(cleanText(orderType) !== 'delivery' || step !== 'dikirim') && 'hidden'} `}>
						<div className='bg-[var(--rose-violet-opacity)] p-2 rounded-lg'>
							<IconDesc className={currentDesc.classNameIcon} />
						</div>
						<div className='text-xs text-gray-700'>{currentDesc?.desc}</div>
					</div>
				)}
				<Delivery />
				<Pickup />
				{/* <Dinein /> */}
			</div>
		</div>
	);
};

export default Status;
